import { useQuery } from 'react-query'
import { apiGetData } from '../../../core/utils/api/generic'
import { CompanyUserType } from '../../../types/shared/RequisitionDataTypes'

export const useUsers = () => useQuery(['users'], () => apiGetData<CompanyUserType[]>('/users'))

export default useUsers
